

































import { Component, Vue, Watch } from "vue-property-decorator";

import { momentTZ as moment } from "@/helpers/moment";
import { NSLog } from "@/helpers/log";
const log = NSLog("/components/AdvancedMenu");

import reportingApi from "@/services/reporting";
import { Mutation } from "vuex-class";

@Component
export default class AdvancedMenu extends Vue {
  @Mutation("showSnack") public showSnack: any;

  private async forceGenSalesReport(req: any) {
    this.showSnack("Requesting sales report generation");
    req.name = "sales";
    try {
      const res = await reportingApi.RequestReportGeneration(req);
      if (res === "ok") {
        this.showSnack("Sales reports generating, go to gdrive");
      } else {
        this.showSnack("Something went wrong");
      }
    } catch (e) {
      this.showSnack("Something went wrong" + e);
    }
  }

  private get salesReportDateRanges() {
    const res: any = [];

    for (let i = 0; i < 6; i++) {
      const v = moment().add(i * -1, "Month");
      res.push({
        title: v.format("MMMYY").toUpperCase(),
        month: +v.format("M"),
        year: +v.format("Y")
      });
    }
    return res;
  }
}
